import React, {useCallback, useEffect, useState} from 'react';
import _ from "lodash";
import Checkbox from "../../../../../components/checkbox";

import {Collapse} from 'react-collapse';

const getNumCheck = (value) => {
    let i = 0;
    _.filter(value,item => {
        if(item.check) i++;
    })
    return i;
}
function Runner(props) {
    const [isOpened, setIsOpened] = useState(false);
    const {selected} = props;
    const [totalCondition, setTotalCondition] = useState({
        none: selected.none,
        available: selected.available
    })
    const [listAvailable] = useState([
        {
            id: '100',
            name: '一塁',
            check: false
        },
        {
            id: '010',
            name: '二塁',
            check: false
        },
        {
            id: '001',
            name: '三塁',
            check: false
        },
        {
            id: '110',
            name: '一二塁',
            check: false
        }, {
            id: '101',
            name: '一三塁',
            check: false
        }, {
            id: '011',
            name: '二三塁',
            check: false
        }, {
            id: '111',
            name: '満塁',
            check: false
        }
    ])
    const [isCheckTotalAvailable, setIsCheckTotalAvailable] = useState(false);
    const [isCheckNone, setIsCheckNone] = useState(false);

    useEffect(() => {
        setIsCheckNone(selected.none ? true : false)
        if (selected.available.length > 0) {
            selected.available.map(item => {
                const index = listAvailable.findIndex(i => i.id === item);
                listAvailable[index].check = true;
            })
            if (selected.available.length === listAvailable.length) setIsCheckTotalAvailable(true);
        }

    }, [selected])
    useEffect(() => {
        props.onChange(totalCondition)
    }, [totalCondition])

    useEffect(() => {
        if (_.isEmpty(totalCondition.available)) {
            setIsCheckTotalAvailable(false)
            return
        }
        if(totalCondition.available.length !== getNumCheck(totalCondition.available)) setIsCheckTotalAvailable(false);
    }, [totalCondition.available])

    const onClickNone = useCallback((val) => {
        setIsCheckNone(!isCheckNone);
        setTotalCondition(state => ({...state, none: state.none ? null : val}))
    }, []);
    const onClickTotalAvailable = useCallback(() => {
        setIsCheckTotalAvailable(!isCheckTotalAvailable);
        if (!isCheckTotalAvailable) {
            const arr = [];
            const cpList = [...listAvailable];
            cpList.forEach(i => {
                arr.push(i.id);
                i.check = true
            })
            setTotalCondition(state => ({...state, available: arr}))
        } else {
            const cpList = [...listAvailable];
            cpList.forEach(i => {
                i.check = false
            })
            setTotalCondition(state => ({...state, available: []}))
        }

    }, [isCheckTotalAvailable])

    const onCheckAvailable = useCallback((val) => {
        const arr = [...totalCondition.available];
        const cpList = [...listAvailable];

        const index = _.indexOf(arr, val);
        const i = _.findIndex(cpList, item => item.id === val)
        if (index === -1) {
            arr.push(val);
            cpList[i].check = true;
        } else {
            arr.splice(index, 1);
            cpList[i].check = false;
        }
        setTotalCondition(state => ({...state, available: arr}));
    })
    return (
        <div className='group-filter-item'>
          <div className={'open-collapse'}>
              <div className='toggle-collapse' onClick={()=> setIsOpened(!isOpened)}>
                  <h4>走者</h4>
                  <img src="/img/chevron_down_24px.svg" alt="arrow-down" style={{transform:isOpened === true && 'rotate(180deg)'}}/>
              </div>

              <Collapse isOpened={isOpened}>
                  <div>
                      <div className='search-main-advanced-checkbox'>
                          <label>
                              <Checkbox id='000' checked={isCheckNone} onClick={() => onClickNone('000')}/>
                              なし
                          </label>
                      </div>
                      <div className='search-main-advanced-checkbox'>
                          <label>
                              <Checkbox checked={isCheckTotalAvailable} onClick={onClickTotalAvailable}/>
                              あり
                          </label>
                      </div>
                      <div className='search-main-analysis-child-item wrap-group'>
                          {listAvailable.map(item => {
                              return (
                                  <div key={item.id} className='search-main-advanced-checkbox'>
                                      <label>
                                          <Checkbox checked={item.check} onClick={() => onCheckAvailable(item.id)}/>
                                          {item.name}
                                      </label>
                                  </div>
                              )
                          })}
                      </div>

                  </div>
              </Collapse>

          </div>
            <div className={'close-collapse'}>
                <div>
                    <h4>走者</h4>
                </div>

                    <div>
                        <div className='search-main-advanced-checkbox'>
                            <label>
                                <Checkbox id='000' checked={isCheckNone} onClick={() => onClickNone('000')}/>
                                なし
                            </label>
                        </div>
                        <div className='search-main-advanced-checkbox'>
                            <label>
                                <Checkbox checked={isCheckTotalAvailable} onClick={onClickTotalAvailable}/>
                                あり
                            </label>
                        </div>
                        <div className='search-main-analysis-child-item wrap-group'>
                            {listAvailable.map(item => {
                                return (
                                    <div key={item.id} className='search-main-advanced-checkbox'>
                                        <label>
                                            <Checkbox checked={item.check} onClick={() => onCheckAvailable(item.id)}/>
                                            {item.name}
                                        </label>
                                    </div>
                                )
                            })}
                        </div>

                    </div>

            </div>
        </div>
    )
}

export default Runner;
